import Vue from 'vue'
import Router from 'vue-router'
import orderDetails from '@/pages/approval/orderDetails'

Vue.use(Router)

export default new Router({
  routes: [
    {
      desc: '上传示例页',
      path: '/example/upload',
      name: 'upload',
      component: resolve => require(['@/pages/example/uploadExample'], resolve)
    },
    {
      desc: '地域示例v-distpicker',
      path: '/example/v-distpicker',
      name: 'area1 example',
      component: resolve => require(['@/pages/example/area1'], resolve)
    },
    {
      desc: '地域示例element-china-area-data',
      path: '/example/element-china-area-data',
      name: 'area2 example',
      component: resolve => require(['@/pages/example/area2'], resolve)
    },
    {
      path: '/primarily_approve',
      name: 'Primaryily_approve',
      component: resolve => require(['@/pages/primarily/primarily'], resolve)
    },
    {
      desc: '综合查询页',
      path: '/query/list',
      name: 'query_list',
      component: resolve => require(['@/pages/query_list'], resolve)
    },
    {
      desc: 'CRM订单查询',
      path: '/crm/order/list',
      name: 'crm_order_list',
      component: resolve => require(['@/pages/crmOrder/list'], resolve)
    },
    {

      desc: '抵押页',
      path: '/mortgage',
      name: 'mortgage page',
      component: resolve => require(['@/pages/mortgage/list'], resolve)
    },

    {
      desc: '初审列表页',
      path: '/first/approval/list',
      name: 'first_approval_list',
      component: resolve => require(['@/pages/firstApproval/list'], resolve)
      // component: HelloWorld1
    },
    {
      desc: '复审列表页',
      path: '/review/approval/list',
      name: 'review_approval_list',
      component: resolve => require(['@/pages/reviewApproval/list'], resolve)
      // component: HelloWorld1
    },
    {
      desc: '终审列表页',
      path: '/final/approval/list',
      name: 'final_approval_list',
      component: resolve => require(['@/pages/finalApproval/list'], resolve)
    },
    {
      desc: 'GPS审批页',
      path: '/gps/approval/list',
      name: 'gps approval list',
      component: resolve => require(['@/pages/gpsApproval/list'], resolve)
    },
    {
      path: '/contract/approval/list',
      name: 'contract approval list',
      component: resolve => require(['@/pages/contract/list'], resolve)
    },
    {
      path: '/mortgage/approval/list',
      name: 'mortgage list',
      component: resolve => require(['@/pages/mortgage/list'], resolve)
      // component: HelloWorld1
    },
    {
      desc: '字段收藏页',
      path: '/appinfo',
      name: 'appinfo',
      component: resolve => require(['@/pages/appinfo/appinfo'], resolve)
    },
    {
      desc: '公共审批详情页',
      path: '/approval/order_details/:operateType/:identity/:approvalStep/:appCode',
      name: 'orderDetails',
      component: {...orderDetails}
    },
    {
      desc: '编辑页',
      path: '/modify/order_details/:operateType/:identity/:approvalStep/:appCode',
      component: {...orderDetails}
    },
    {
      desc: '回到顶部的Demo',
      path: '/demo/backTop',
      component: resolve => require(['@/pages/example/backTopDemo'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js